import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";

const CustomRouterLink = forwardRef((props, ref) => (
  <React.Fragment ref={ref}>
    <NavLink {...props} />
  </React.Fragment>
));

export default CustomRouterLink;
